import { MutationTree } from 'vuex';
import { BannerStandImagesState, BannerStandImagesMutations } from './types';
import BannerStandImage from './banner-stand-image';
import { ListStatus, EditableStatus } from '@/store/types';
import Vue from 'vue';
import { updateEditable } from '@/store/utils/editable';

export const mutations: MutationTree<BannerStandImagesState> = {
  [BannerStandImagesMutations.SET_ALL](state, items: BannerStandImage[]) {
    state.list = items;
  },

  [BannerStandImagesMutations.SET_ALL_STATUS](state, status: ListStatus) {
    state.listStatus = status;
  },

  [BannerStandImagesMutations.SET_EDITABLE](state, item: BannerStandImage | null) {
    Vue.set(state, 'editable', item);
    Vue.set(state, 'initialEditable', item ? BannerStandImage.clone(item) : null);
  },

  [BannerStandImagesMutations.SET_EDITABLE_STATUS](state, status: EditableStatus) {
    state.editableStatus = status;
  },

  [BannerStandImagesMutations.SET_LIST_PAGINATION](state, pagination: { currentPage: number; lastPage: number; total: number }) {
    state.listPagination = pagination;
  },

  [BannerStandImagesMutations.UPDATE_EDITABLE]: updateEditable<BannerStandImagesState>('editable'),
  [BannerStandImagesMutations.UPDATE_INITIAL_EDITABLE]: updateEditable<BannerStandImagesState>('initialEditable'),

  [BannerStandImagesMutations.SET_PRODUCTS](state, products: { id: number; title: string }[]) {
    state.products = products;
  },

  [BannerStandImagesMutations.SET_USED_PRODUCTS](state, usedProducts: number[]) {
    state.usedProducts = usedProducts;
  },

  [BannerStandImagesMutations.SET_EXISTING_LANGUAGES](state, existingLanguages: string[]) {
    state.existingLanguages = existingLanguages;
  },
};

